import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheckCircle, faDotCircle} from '@fortawesome/free-regular-svg-icons'

export default function TutorProfileAvailability({tutorProfile}) {
  const availabilityAttributes = {
    availableWeekdayDays: "Weekday daytime",
    availableWeekdayEvenings: "Weekday evenings",
    availableWeekends: "Weekends"
  }

  const availabilityKeys = Object.keys(availabilityAttributes)

  return (
    <div>
      {availabilityKeys.map(availabilityKey =>{
        const hasAvailability = tutorProfile[availabilityKey]

        return (
          <div className="mb-2" key={availabilityKey}>
            <FontAwesomeIcon
              icon={hasAvailability ? faCheckCircle : faDotCircle}
              fixedWidth
              className={`me-1 ${hasAvailability ? 'text-success' : 'text-muted'}`}
            />
            <span className={!hasAvailability ? 'text-secondary text-decoration-line-through' : ''}>
              {availabilityAttributes[availabilityKey]}
            </span>
          </div>
        )
      })}
    </div>
  )
}
